import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
// import Section3 from "./Section3";
// import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";
import Section12 from "./Section12";
import Section13 from "./Section13";
import Section14 from "./Section14";
import Section15 from "./Section15";
import Section16 from "./Section16";
import Section17 from "./Section17";
import Section18 from "./Section18";
import Section19 from "./Section19";
import Section20 from "./Section20";





const WebDevelopment = () => {
  return (
    <div className="pt-[160px] sm:pt-0">
      <Helmet>
        <title>Web Design and Development Services | Mean3</title>
        <meta
          name="description"
          content="Partner with Mean3 for custom web design and development. We build ecommerce sites, business websites and apps that drive growth"
        />
      </Helmet>
      <Section1 />
      <div className="bg-gray-100">
        <Section2 />
        {/* <Section3/>
        <Section4/> */}
        <Section14/>
        <Section15/>
        {/* <Section16/> */}
        <Section20/>
        <Section17/>
        {/* <Section5/> */}
        <Section6/>
        <Section7/>
        {/* <Section8/> */}
        <Section9/>
        <Section10/>
        {/* <Section11/> */}
        <Section12/>
        <Section19/>
        <Section13/>
        <Section18/>

      </div>
    </div>
  );
};

export default WebDevelopment;
